const GUEST_ID_KEY = 'guestId';

/**
 * Stable anonymous id for a guest (a visitor who hasn't signed in), created on
 * first read and kept in localStorage. It is a local display/analytics marker
 * only — never sent as an authorization credential. Real server-side identity
 * comes solely from a Google session.
 */
export function getGuestID(): string {
  let id = localStorage.getItem(GUEST_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(GUEST_ID_KEY, id);
  }
  return id;
}
